import loginIcon from "@assets/icons/Login.svg";
import loginActiveIcon from "@assets/icons/Login_active.svg";
import hexagonIcon from "@assets/icons/Hexagon.svg";
import medicineIcon from "@assets/icons/Medicine.svg";
import sectionIcon from "@assets/icons/Section.svg";
import { useSendPasswordResetLinkMutation } from "@store/user";
import { IconButton } from "@common/Buttons";
import { Form, Input } from "antd";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [sendPasswordResetLink, { isLoading }] =
    useSendPasswordResetLinkMutation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  
  //handle send password reset link
  const handleSendPasswordResetLink = async () => {
    try {
      const values = await form.validateFields();
      sendPasswordResetLink({
        email: values.email,
        navigate,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="overflow-hidden relative w-full h-screen">
      {/* Left  */}
      <div className="w-[60vw] hidden md:block h-full origin-top-right -skew-x-20 bg-secondary-main absolute top-0 left-0 z-20">
        <div
          className="absolute bottom-0 left-0 w-full h-screen bg-bottom bg-no-repeat bg-cover skew-x-20"
          style={{ backgroundImage: `url(${hexagonIcon})` }}
        ></div>
        <div
          className="flex absolute left-24 justify-center items-center w-full h-screen bg-center bg-no-repeat bg-contain lg:left-16 skew-x-20"
          style={{ backgroundImage: `url(${sectionIcon})` }}
        ></div>
        <div
          className="flex absolute left-24 justify-center items-center w-full h-screen bg-center bg-no-repeat bg-contain lg:left-16 skew-x-20"
          style={{ backgroundImage: `url(${medicineIcon})` }}
        ></div>
      </div>

      {/* Right */}
      <div className="w-[68vw] hidden md:block lg:w-[60vw] h-full origin-bottom-left -skew-x-20 bg-primary-tint-light absolute top-0 right-0 z-10">
        <div className="absolute inset-0 flex flex-col w-[340px] text-balance xl:text-pretty left-[70px] lg:left-32 2xl:left-40 justify-center gap-5 skew-x-20">
          <h1 className="font-bold text-secondary-main text-[32px]">
            Forgot Password?
          </h1>
          <p className="text-sm !font-sans leading-6 text-secondary-main">
            Enter your email to receive a password reset link.
          </p>

          <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            className="!flex !flex-col !gap-6 [&_.ant-form-item-label]:!pb-0"
          >
            <div className="!flex !flex-col gap-1">
              {/* email */}
              <Form.Item
                name="email"
                label={<label className="!text-xs !text-white">Email</label>}
                rules={[{ required: true, message: "Please enter your email" }]}
                className="!mb-0"
              >
                <Input
                  placeholder="Enter your email"
                  className="!rounded-[8px] !h-9 !text-xs"
                />
              </Form.Item>
            </div>

            <IconButton
              loading={isLoading}
              icon={loginIcon}
              activeIcon={loginActiveIcon}
              className="flex items-center gap-2 flex-row-reverse transition-all duration-300 !font-medium px-5 w-fit h-10 !rounded-md !text-sm !text-[#333333] hover:!text-secondary-main hover:!bg-primary-tint-light bg-secondary-main !leading-snug hover:!border hover:!border-secondary-main"
              onClick={handleSendPasswordResetLink}
              label={"Send Password Reset Link"}
            />
          </Form>
        </div>
      </div>

      {/* mobile */}
      <div className="flex flex-col gap-3 justify-center items-center h-full text-balance bg-primary-tint md:hidden">
        <h1 className="font-bold text-secondary-main text-[32px]">
          Forgot Password?
        </h1>
        <p className="text-sm !font-sans leading-6 text-center text-secondary-main">
          Enter your email to receive a password reset link.
        </p>

        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          className="!flex !flex-col !gap-6 !w-full !px-12"
        >
          <div className="!flex !flex-col">
            {/* email */}
            <Form.Item
              name="email"
              label={<label className="!text-xs !text-white">Email</label>}
              rules={[{ required: true, message: "Please enter your email" }]}
              className="!mb-0"
            >
              <Input
                placeholder="Enter your email"
                className="!rounded-[8px] !h-10 !text-xs"
              />
            </Form.Item>
          </div>
          <IconButton
            loading={isLoading}
            icon={loginIcon}
            activeIcon={loginActiveIcon}
            className="flex items-center gap-2 flex-row-reverse !font-medium mt-6 px-5 w-fit transition-all duration-300 h-10 !rounded-md text-sm !text-[#333333] hover:!text-secondary-main hover:!bg-primary-tint-light hover:!border bg-secondary-main !leading-snug  hover:!border-secondary-main"
            onClick={handleSendPasswordResetLink}
            label={"Send Password Reset Link"}
          />
        </Form>
      </div>
    </div>
  );
}
